import { ChangeDetectionStrategy, Component, computed, Inject, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractDialogData, AnimationDialogService, DialogAbstractComponent } from '@pc/dialog-abstract';
import {
  QuoteCoversData,
  QuoteOverviewLabels,
  QuoteOverviewPopupData,
  QuoteTripDetailsData,
  TripDetailsIcons
} from '@pc/shared';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { IconComponent } from '@pc/icon';
import { SeparatorComponent } from '@pc/separator';
import { QuoteOverviewContentComponent } from '../quote-overview-content/quote-overview-content.component';
import { EnvironmentService } from '../../../environment/environment.service';
import { SafeHtml } from '@angular/platform-browser';
import { EProcessType } from '@pc/common';
import { QuoteOverviewService } from '../../../shared/services/quote/quote-overview.service';

@Component({
  selector: 'pc-quote-overview-popup',
  standalone: true,
  imports: [CommonModule, DialogAbstractComponent, IconComponent, SeparatorComponent, QuoteOverviewContentComponent],
  templateUrl: './quote-overview-popup.component.html',
  styleUrl: './quote-overview-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteOverviewPopupComponent {
  public isMobile = false;
  public totalPrice = signal(0);
  public quoteOverviewLabels: QuoteOverviewLabels = {} as QuoteOverviewLabels;
  public quoteTripDetailsData: QuoteTripDetailsData = {} as QuoteTripDetailsData;
  public privacyPolicyLink: SafeHtml;
  public quoteCoversData: QuoteCoversData[] = [];
  public closeIcon = '';
  public tripDetailsIcons: TripDetailsIcons = {} as TripDetailsIcons;
  public isStandalone = false;
  public envService = inject(EnvironmentService);
  public quoteOverviewService = inject(QuoteOverviewService);
  public gstRate = this.envService.environment.gstRate;
  public processType = computed<EProcessType>(() => this.quoteOverviewService.getProcessType());
  public showEmailSection = computed<boolean>(() => this.quoteOverviewService.showEmailSection());
  public ProcessTypes = EProcessType;
  private dialogRef = inject(DialogRef);
  private animationDialogService = inject(AnimationDialogService);

  constructor(@Inject(DIALOG_DATA) public data: AbstractDialogData<QuoteOverviewPopupData>) {
    this.populateQuoteOverviewPopupFields();
  }

  public closeQuoteOverview(): void {
    this.animationDialogService.closeDialogWithAnimation(this.dialogRef);
  }

  public setBrokerFee(fee: number): void {
    this.quoteOverviewService.setBrokerFee(fee);
  }

  private populateQuoteOverviewPopupFields(): void {
    const event = this.data.event;
    if (!event) return;

    Object.assign(this, event);
  }
}
